import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide3 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={2} total={total} onActive={onActive} label="Legal Stance">
      <div className="absolute inset-0 flex items-center justify-start overflow-hidden pointer-events-none">
        <div className="watermark whitespace-nowrap pl-6 md:pl-12">NOT A LOTTERY</div>
      </div>

      <div className="relative z-10 flex flex-col h-full w-full max-w-7xl px-6 md:px-12">
        <div className="overline mb-8 shrink-0">{t.overline}</div>
        <div className="ml-auto max-w-4xl lg:pr-12 flex-1 pb-12">
          <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter max-w-2xl">
            {t.heading}
          </h2>
          <p className="mt-8 text-lg text-neutral-300 font-light leading-relaxed max-w-2xl">
            {t.body}
          </p>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Avoid Column */}
            <div className="space-y-3">
              <div className="font-mono text-xs tracking-widest text-neutral-500 mb-2 px-1">
                {t.colAvoid}
              </div>
              {t.avoid.map((a, i) => (
                <div
                  key={i}
                  className="glass rounded-xl px-5 py-4 flex items-start gap-4 lift"
                  data-testid={`s3-avoid-${i}`}
                >
                  <span className="font-mono text-xs text-red-400/80 tracking-widest shrink-0 mt-0.5">
                    ✕
                  </span>
                  <span className="text-sm md:text-base text-neutral-200 leading-tight">{a}</span>
                </div>
              ))}
            </div>

            {/* Do Column */}
            <div className="space-y-3">
              <div className="font-mono text-xs tracking-widest text-[var(--ph-accent)] mb-2 px-1">
                {t.colDo}
              </div>
              {t.doInstead.map((d, i) => (
                <div
                  key={i}
                  className="glass-strong border border-white/5 rounded-xl px-5 py-4 flex items-start gap-4 lift"
                  data-testid={`s3-do-${i}`}
                >
                  <span className="font-mono text-sm text-emerald-400/80 tracking-widest shrink-0">
                    ✓
                  </span>
                  <span className="text-sm md:text-base text-neutral-200 leading-tight">{d}</span>
                </div>
              ))}
            </div>
          </div>

        <div className="accent-line mt-12 mb-4" />
        <div className="font-mono text-xs tracking-widest text-[var(--ph-accent)]">
          {t.footer.toUpperCase()}
        </div>
        </div>
      </div>
    </SlideShell>
  );
};


